var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cv-row",class:[
    (_vm.carbonPrefix + "--row"),
    ( _obj = {}, _obj[(_vm.carbonPrefix + "--row--condensed")] = _vm.kind === 'condensed', _obj[(_vm.carbonPrefix + "--row--narrow")] = _vm.kind === 'narrow', _obj ) ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }